<div class="layoutBlock">
    <div class="columnThreeQuarter">

        <!-- #anchor dynamic field container -->
        <ng-template #dynamicFieldSetContainer></ng-template>

        <res-publication-edit-documents-data [publication]="publication" [hisDynamicContent]="'fs.res.publication.Publication.textAbstract'" [dynamicComponent]="publication._dynamicComponent">
        </res-publication-edit-documents-data>

        <res-publication-edit-contact-data *ngIf="isContactPanelVisible()" [publication]="publication" [hisDynamicContent]="'fs.res.publication.Publication.textAbstract'" [dynamicComponent]="publication._dynamicComponent">
        </res-publication-edit-contact-data>

        <!-- #anchor dynamic field container -->
        <ng-template #dynamicFieldSetContainer></ng-template>

    </div>
</div>
